import script from "./createCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./createCampaign.vue?vue&type=script&setup=true&lang=js"

import "./createCampaign.vue?vue&type=style&index=0&id=abee9d32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abee9d32"]])

export default __exports__